import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { SuitabilityScore } from '../../models/agents/suitability-score';
import { CompanyService } from '../../services/company.service';
import { PersonService } from '../../services/person.service';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs/Observable';
import {
  SuitabilityScoreState,
  SuitabilityScoreModel
} from '../state/suitability-score.state';
import { PersonType } from '../../models/enums/person-type.enum';

@Injectable()
export class SuitabilityScoreBehaviorService {
  @Select(SuitabilityScoreState.score)
  score$: Observable<SuitabilityScoreModel>;

  constructor(
    protected companyService: CompanyService,
    protected personService: PersonService,
    protected store: Store
  ) {}

  pontuation = {};
  suitabilityPontiation: SuitabilityScore = {};

  public messageSource = new BehaviorSubject(this.suitabilityPontiation);
  currentMessage = this.messageSource.asObservable();

  setPontuation(pontuation: any) {
    this.pontuation = pontuation;
    this.calculareScore();
  }

  calculareScore() {
    // TO DO: Refactoring to delete this calculate score method

    try {
      this.score$.subscribe((state) => {
        let score = 0;
        let profile: string;
        Object.keys(this.pontuation).forEach(
          (field) => (score = score + Number(this.pontuation[field]))
        );

        if (state.personType === PersonType.Fisica) {
          if (score <= 16) {
            profile = 'Conservador';
          } else if (score > 16 && score <= 24) {
            profile = 'Moderado';
          } else if (score > 24 && score <= 32) {
            profile = 'Arrojado';
          }
        } else {
          if (score <= 16) {
            profile = 'Conservador';
          } else if (score > 16 && score <= 24) {
            profile = 'Moderado';
          } else if (score > 24 && score <= 32) {
            profile = 'Arrojado';
          }
        }

        if (score === 0 || score === undefined || score === null) {
          console.warn('Suitability Score Zero', score);
        }

        this.messageSource.next({ score: score, profile: profile });
      });
    } catch (error) {
      console.error('Error in calculating suitability score', error);
    }
  }

  calculatePontuation() {
    this.calculareScore();
  }

  setBrithday(brithday: Date) {
    let points = 0;
    const diffYears = this.diffYears(new Date(), brithday);

    if (diffYears <= 24) {
      points = 5;
    } else if (diffYears >= 25 && diffYears <= 35) {
      points = 4;
    } else if (diffYears >= 36 && diffYears <= 45) {
      points = 3;
    } else if (diffYears >= 46 && diffYears <= 60) {
      points = 2;
    } else {
      points = 1;
    }

    this.pontuation['brithdayPontuation'] = points;
    this.calculatePontuation();
  }

  setAverageIncome(average: number, key: string) {
    let pontuation = 0;
    if (average <= 1000) {
      pontuation = 1;
    } else if (average > 1000 && average <= 3000) {
      pontuation = 2;
    } else if (average > 3000 && average <= 5000) {
      pontuation = 3;
    } else if (average > 5000 && average <= 10000) {
      pontuation = 4;
    } else if (average > 10000) {
      pontuation = 5;
    }

    if (!this.pontuation[key]) {
      this.pontuation[key] = pontuation;
      this.calculatePontuation();
    }
  }

  setInvestmentsCompositionAverage(pontuation: number, key: string) {
    if (!this.pontuation[key]) {
      this.pontuation[key] = pontuation;
      this.calculatePontuation();
    }
  }

  changePontuation(key: string, pontuation: number) {
    if (!this.pontuation[key]) {
      this.pontuation[key] = pontuation;
      this.calculatePontuation();
    }
  }

  diffYears(dt2: Date, dt1: Date): number {
    let diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60 * 24;
    return Math.abs(Math.round(diff / 365.25));
  }
}
